export let HubletOption;
(function (HubletOption) {
  HubletOption["na1"] = "na1";
  HubletOption["eu1"] = "eu1";
})(HubletOption || (HubletOption = {}));